import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsertionDirective } from './insertion.directive';
import { ModalLateralComponent } from './modal-lateral.component';

@NgModule({
	declarations: [ModalLateralComponent, InsertionDirective],
	imports: [CommonModule],
	entryComponents: [ModalLateralComponent]
})
export class ModalLateralModule {}
